<template>
  <div class="home">
    <WebView v-show="!state"></WebView>
    <AppView v-show="state"></AppView>
  </div>
</template>

<script>
// @ is an alias to /src
import AppView from "@/components/WebView.vue";
import WebView from "@/components/WebView.vue";

export default {
  name: "HomeView",
  components: {
    WebView,
    AppView,
  },
  data() {
    return {
      state: true,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const isMobile = window.innerWidth <= 768; // 根据实际需要设置移动端的阈值

      if (isMobile) {
        console.log("移动端");
        this.state = true;
      } else {
        console.log("pc端");
        this.state = false;
      }
    },
  },
};
</script>

<style scoped>
.home {
  height: 100%;
  width: 100%;
}
</style>
